module.exports = __webpack_public_path__ + "img/music.86c8fa58.png";